"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var CustomPropTypes = _interopRequireWildcard(require("../../../../constants/PropTypes"));

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIToggleGroup = _interopRequireDefault(require("UIComponents/input/UIToggleGroup"));

var Sync = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/dataSyncs/Sync"));

var _i18n = require("../../../../utils/i18n");

var _RadioInput = _interopRequireDefault(require("../inputs/RadioInput"));

var ALL = 'ALL';

var dataSyncsOrder = _immutable.default.OrderedSet([ALL, Sync.INBOUND, Sync.OUTBOUND, Sync.BOTH]);

var _getDataSyncFilterI18nKey = function _getDataSyncFilterI18nKey(sync) {
  switch (sync) {
    case ALL:
      return 'appMarketplace.storefront.filters.sync.items.all';

    default:
      return (0, _i18n.getDataSyncFilterI18nKey)(sync);
  }
};

var DataSyncDirectionToggleGroup = function DataSyncDirectionToggleGroup(_ref) {
  var _onChange = _ref.onChange,
      value = _ref.value;
  return _react.default.createElement(_UIToggleGroup.default, {
    name: "data-syncs"
  }, dataSyncsOrder.map(function (sync) {
    return _react.default.createElement(_RadioInput.default, {
      key: sync,
      checked: value ? value === sync : sync === ALL,
      onChange: function onChange(_ref2) {
        var inputValue = _ref2.target.value;

        _onChange(inputValue === ALL ? null : inputValue);
      },
      value: sync
    }, _react.default.createElement(_FormattedMessage.default, {
      message: _getDataSyncFilterI18nKey(sync)
    }));
  }));
};

DataSyncDirectionToggleGroup.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  value: CustomPropTypes.dataSyncDirection
};
var _default = DataSyncDirectionToggleGroup;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/filters/DataSyncDirectionToggleGroup.js
// module id = 726
// module chunks = 209 210 211 212